<template>

    <div class="min-h-screen flex flex-col overflow-hidden">

        <navbar></navbar>

        <!-- <site-alerts></site-alerts> -->

        <!-- If chasers are live -->

        <div id="michael-backdrop" class="w-full">
            <div class="container mx-auto py-10 px-2">
                <div class="w-full text-center">
                    <h1 class="text-white uppercase">Live video of all of mother nature's extremes.</h1>
                </div>
                <div class="flex flex-row flex-wrap mt-8">
                    <div class="w-full md:w-1/2 pr-4 text-white">
                        <p class="text-lg"><strong>Live Storm Chasing</strong> is the most interactive and immersive storm chasing experience available on the platforms you use most: computers, mobile devices, and TV's.</p>

                        <p class="text-lg mt-4">This video (if you haven't watched the video yet we suggest you do) is just a flavor of the LIVE content that you can find on Live Storm Chasing.
                            In fact, the events that took place in the video happened live for over 5,000 live viewers on October 10, 2018, right here on this platform.</p>

                        <p class="text-lg mt-4">While chasers are not live 24/7, we do have video-on-demand content which features highlights of their chases. Some storm chasers who do not wish to stream can still feature their video on our site!</p>
                    </div>
                    <div class="w-full md:flex-1 mt-6 md:mt-0">
                        <div class="embed-responsive embed-responsive-16by9">
                            <video-on-demand-player class="embed-responsive-item"></video-on-demand-player>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container mx-auto py-4 mt-4" v-if="alert !== null">
            <div class="bg-red rounded w-full text-white p-4">
                <strong>{{ alert.headline }}</strong>
                <p class="mt-2">{{ alert.message }}</p>
            </div>
        </div>

        <div class="bg-grey-darkest px-2" v-if="!loading && liveChasers.length > 0">
            <div class="container mx-auto py-4">
                <div class="flex items-center -ml-2">
                    <div><div class="blob"></div></div>
                    <h2 class="text-grey-lightest">Live Chasers</h2>
                </div>

                <div class="flex flex-row flex-wrap mt-4 -mx-2">
                    <div class="w-full md:w-1/2 lg:w-1/3 mb-5 select-none px-2 cursor-pointer" v-for="chaser in liveChasers" v-on:click="goToChaser(chaser)">
                        <div id="holder" class="h-auto">
                            <div id="anim" class="relative">
                                <img class="rounded-lg shadow-md z-0" :src="'http://edge.livestormchasing.com/thumbnails/' + chaser.stream_keys[0].stream_id + '.jpg?t=' + new Date().getTime()" />

                                <div class="mx-auto absolute z-10 w-full">
                                    <div class="bg-white mx-auto rounded-lg w-5/6 -mt-12">
                                        <div class="w-full flex flex-1 px-4 relative items-center py-2 no-underline">
                                            <div>
                                                <img :src="'//www.gravatar.com/avatar/' + chaser.gravatar_hash + '?s=80&amp;d=retro&amp;r=g'" alt="Avatar" class="h-10 w-10 rounded-full mr-2">
                                            </div>
                                            <div class="pl-1">
                                                <div class="text-lg text-grey-darkest">{{ chaser.name }}</div>
                                                <div class="text-grey-darker" v-if="chaser.location !== undefined && chaser.location !== null">{{ chaser.location.location_text }}</div>
                                                <div class="text-grey-darker" v-if="chaser.location == undefined || chaser.location == null  || chaser.location.location_text == null">Location Unavailable</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="bg-grey-darkest px-2">
            <div class="container mx-auto py-4">
                <h2 class="text-grey-lightest">Recent Videos</h2>
                <p class="text-grey-dark mt-1">View our chasers' most recent video from their chases. Chasers typically upload 2-3 high quality videos per chase!</p>

                <div class="flex flex-row flex-wrap -mx-2" v-if="!loading">
                    <div class="w-full md:w-full lg:w-1/2 px-2 cursor-pointer" v-for="video in videos" v-on:click="goToVideo(video)">
                        <div id="holder" class="h-auto">
                            <div id="anim" class="relative">
                                <div class="flex flex-col sm:flex-row mt-4 rounded-lg bg-white select-none">
                                    <img class="h-auto sm:h-24 rounded-t-lg sm:rounded-l-lg sm:rounded-r-none" style="object-fit: cover;" :src="thumbnailImage(video.created_at, video.upload_id)" />
                                    <div class="p-2 flex flex-col justify-between">
                                        <strong>{{ video.title }}</strong>
                                        <p class="text-sm text-grey-dark mt-1 sm:mt-0">{{ video.user }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flex flex-row justify-center" v-if="loading">
                    <div class="text-center py-10">
                        <h1><i class="fas fa-spinner-third fa-spin text-grey-light"></i></h1>
                    </div>
                </div>

            </div>
        </div>

        <div class="flex-1 bg-grey-darkest border-b-2 border-grey-darkest pt-5 px-2">

            <div class="container mx-auto text-white">
                <h2 class="text-grey-lightest">Mobile App</h2>
                <p class="text-grey-dark mt-1">Live Storm Chasing is the best way to discover, follow, interact with, and support storm chasers. Follow your chasers on the go using our new and improved mobile application. From
                    live chaser video showing different visual angles of the storm, users are able to also view radar, storm reports, and satellite imagery. Users can also chat view past storm videos
                    where new videos are posted almost daily. Finally, users can follow chasers and be notified when they go live or enter a tornado warning.
                </p>
                <div class="flex flex-row mt-4">
                    <a class="py-2 px-3 bg-blue rounded-full text-white no-underline" href="https://itunes.apple.com/us/app/live-chasing/id1124296614?mt=8" target="_blank">
                        <i class="fab fa-apple"></i> iOS
                    </a>
                    <a class="py-2 px-3 bg-blue rounded-full text-white no-underline ml-4" href="https://play.google.com/store/apps/details?id=tv.livewx.livechasing&hl=en_US" target="_blank">
                        <i class="fab fa-android"></i> Android
                    </a>
                </div>
            </div>

            <div class="flex flex-wrap item-center container mx-auto justify-center py-4">
                <img class="w-64 h-full mx-4 my-4 grow" src="@/assets/images/app/home.jpg" />
                <img class="w-64 h-full mx-4 my-4 grow" src="@/assets/images/app/chaser.jpg" />
                <img class="w-64 h-full mx-4 my-4 grow" src="@/assets/images/app/video.jpg" />
                <img class="w-64 h-full mx-4 my-4 grow" src="@/assets/images/app/map.jpg" />
            </div>

        </div>




        <div class="flex-1 bg-black border-b-2 border-grey-darkest pt-5" >

            <div class="container mx-auto text-center text-white ">
                <h4 class="uppercase">As seen on these media networks</h4>
            </div>

            <div class="flex flex-wrap item-center container mx-auto justify-center py-4">
                <img class="h-16 filter-grayscale mx-4 my-4 grow" src="@/assets/images/logos/gma.png" />
                <img class="h-16 filter-grayscale mx-4 my-4 grow" src="@/assets/images/logos/today.png" />
                <img class="h-16 filter-grayscale mx-4 my-4 grow" src="@/assets/images/logos/cnn.png" />
                <img class="h-16 filter-grayscale mx-4 my-4 grow" src="@/assets/images/logos/twc.png" />
                <img class="h-16 filter-grayscale mx-4 my-4 grow" src="@/assets/images/logos/fox.png" />
                <img class="h-16 filter-grayscale mx-4 my-4 grow" src="@/assets/images/logos/nbc.png" />
                <img class="h-16 filter-grayscale mx-4 my-4 grow" src="@/assets/images/logos/wn.png" />
                <img class="h-16 filter-grayscale mx-4 my-4 grow" src="@/assets/images/logos/sinclair.png" />
            </div>

        </div>

        <page-footer></page-footer>

    </div>
</template>

<script>

    import * as Config from '../config'

    import VideoOnDemandPlayer from '@/components/VideoOnDemandPlayer'
    import SiteAlerts from '@/components/SiteAlerts'
    import Navbar from '@/components/Navbar'
    import PageFooter from '@/components/PageFooter'
    import { Carousel, Slide } from 'vue-carousel';
    import ProfileImage from '@/components/Modules/ProfileImage'
    import moment from 'moment'

    export default {
        name: 'home',
        components: {
            VideoOnDemandPlayer,
            PageFooter,
            Carousel,
            Slide,
            Navbar,
            SiteAlerts,
            ProfileImage
        },
        data() {
            return {
                liveChasers: [],
                videos: [],
                alert: null,
                
                loading: true,
            }
        },
        mounted() {
            this.getHomeData()

            /* 
                Homepage call:
                    - Live chasers (limit 3)
                    - Recent videos (limit 8)
                    - Any site notifications
                    - Cache 1 min
            */
        },
        methods: {
            getHomeData() {
                this.$http.get(Config.apiPath + "/api/v1/home").then((response) => {
                    this.$set(this, 'videos', response.data.videos);
                    this.$set(this, 'liveChasers', response.data.liveChasers);
                    this.$set(this, 'alert', response.data.alert);
                    this.$set(this, 'loading', false);
                });
            },
            thumbnailImage(date, id) {
                var date = moment.utc(date);
                var isAfter = moment(date).isAfter('2018-05-27 00:06:00');

                if(isAfter) {
                    return 'https://media-preview.livestormsvideo.com/thumbnails/' + date.year() + "/" + (date.month() + 1) + "/" + date.date() + "/" + id + "-00001.png";
                }
                return 'https://lsm-mms.s3.amazonaws.com/thumbnails/' + date.year() + "/" + (date.month() + 1) + "/" + date.date() + "/" + id + "-1.jpg";
            },
            goToChaser(chaser) {
                this.$router.push({ name: 'ChasersProfile', params: {profile: chaser.username} })
            },
            goToVideo(video) {
                window.open('https://youtu.be/' + video.youtube_id, '_blank');
            }
        },
    }

</script>

<style>
    .navbar-logo {
        max-height: 40px;
        width: auto;
    }
    .embed-responsive.embed-responsive-16by9 {
        padding-bottom: 56.25%;
    }
    .embed-responsive {
        position: relative;
        display: block;
        height: 0;
        padding: 0;
        overflow: hidden;
    }
    .embed-responsive .embed-responsive-item, .embed-responsive iframe, .embed-responsive embed, .embed-responsive object {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
    }

    #michael-backdrop {
        background:
            linear-gradient(
              rgba(0, 0, 0, 0.45),
              rgba(0, 0, 0, 0.45)
            ), url("~@/assets/images/hurricane-michael.jpg");
        background-position: center center;
        background-size: cover;
    }

    .h-120 {
        height: 36rem;
    }

    .-mt-64 {
        margin-top: -36rem;
    }

    .filter-grayscale {
        filter: grayscale(100%);
    }

    .filter-grayscale:hover{
        filter: none;
        -webkit-transition : -webkit-filter 200ms linear;
    }

    .grow {
        transition: all .4s ease-in-out;
    }

    .grow:hover {
        transform: scale(1.1);
    }

    .rotate-10deg {
         transform: rotate(-7.5deg);
        -ms-transform: rotate(-7.5deg); /* IE 9 */
        -webkit-transform: rotate(-7.5deg); /* Chrome, Safari, Opera */
    }

    #stripe {
        width: 100%;
        height: 100%;
        overflow: hidden;
        -webkit-transform: skewY(-7deg);
        -webkit-transform-origin: 0;
        transform-origin: 0;
        background: linear-gradient(150deg,#3e1bec 15%,#52c0d6 70%,#88ffba 94%);

    }

    #holder:active #anim {
        transform: scale(0.97)
    }
    .img-responsive-16by9 {
        display: block;
        height: 0;
        padding-bottom: 56.25%;
        overflow: hidden;
    }

.blob {
	background: #EA2027;
	border-radius: 50%;
	margin: 10px;
	height: 14px;
	width: 14px;

	box-shadow: 0 0 0 0 #EA2027;
	transform: scale(1);
	animation: pulse 2s infinite;
}

@keyframes pulse {
	0% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(234, 32, 39,0.7);
	}

	70% {
		transform: scale(1);
		box-shadow: 0 0 0 12px rgba(234, 32, 39,0)
	}

	100% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(234, 32, 39,0)
	}
}
</style>
